import {Skeleton} from '@/components/ui/skeleton/Skeleton'
import {StyledAccessesValidatorListItemSkeletonContainer} from './style'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'

export const AccessesValidatorSkeleton = () => {
    return (
        <Flexbox direction="column" gap={2}>
            {Array.from({length: 5}).map((_, index) => (
                <StyledAccessesValidatorListItemSkeletonContainer key={index}>
                    <Skeleton height={20} width={24} />
                    <Skeleton height={40} width={'100%'} />
                    <Skeleton height={40} width={'100%'} />
                    <Skeleton height={40} width={'100%'} />
                    <Skeleton height={58} width={'100%'} style={{borderRadius: '8px'}} />
                    <Skeleton height={58} width={'100%'} style={{borderRadius: '8px'}} />
                    <Skeleton height={58} width={'100%'} style={{borderRadius: '8px'}} />
                    <Skeleton height={40} width={'100%'} />
                    <Skeleton height={20} width={24} />
                </StyledAccessesValidatorListItemSkeletonContainer>
            ))}
        </Flexbox>
    )
}
